import { FormDialog } from 'components/dialog/form'
import { SearchsDiseaseResult, usePostSearchsDisease } from 'interface/search/disease'
import { useSearchsDiseaseForm, SearchsDiseaseForm } from '../form'

type AddSearchsDiseaseDialogProps = {
  searchId: number
  onSubmit: (result: SearchsDiseaseResult) => void
  onClose: () => void
}
export const AddSearchsDiseaseDialog = ({
  searchId,
  onSubmit,
  onClose
}: AddSearchsDiseaseDialogProps) => {
  const [postState, submit] = usePostSearchsDisease(searchId, { onPosted: onSubmit })
  const form = useSearchsDiseaseForm({ onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="分析対象の疾患を登録"
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsDiseaseForm form={form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
